<template>
	<div :class="{'settings-group':true,'toggled':toggled,toggleable:!hideToggle}" @click="toggleItAction ( $event, true )">

		<h4 class="settings-group-title" v-if="titleProcessed"><span v-html="titleProcessed" /> <span class="toggle-link" v-if="!hideToggle" @click="toggleItAction ( $event, false )" v-html="toggled?'&lt;&lt; Hide &gt;&gt;':'&lt;&lt; Click here to view/edit &gt;&gt;'" /></h4>


		<div class="settings-group-toggle" v-if="toggled||!titleProcessed">
			
			<p class="settings-group-description" v-if="descriptionProcessed" v-html="descriptionProcessed" />

			<div class="settings-group-grid three" v-if="formInputs.first.length">
				<div class="setting-group" v-for="input in formInputs.first" :key="input.name">
					<label class="input-label">{{ input.label }}</label>
					<FormInput
						type="number"
						v-model.number="componentSettings[input.name]"
						:min="input.min"
						:max="input.max"
						:name="input.name"
						:id="'report-component-dim-' + input.name"
						:placeholder="input.placeholder"
						:required="false"
						:noMarginBottom="true"
						:step="input.step"
						:class="{'setting-group-input':true,'highlight':!!input.highlight}"
					/>
				</div>

				<div class="setting-group" v-if="allowedInputs.indexOf('alignment') >= 0">
					<label class="input-label">Alignment</label>
					<v-select
						v-model="componentSettings.alignment"
						:options="alignmentOptions"
						:reduce="(option) => option.value"
						label="label"
						placeholder="Defaults to Left"
						:clearable="true"
						:searchable="false"
						:append-to-body="true"
					/>
				</div>
			</div>
			<div class="settings-group-grid">
				<div class="setting-group" v-for="input in formInputs.second" :key="input.name">
					<label class="input-label">{{ input.label }}</label>
					<FormInput
						type="number"
						v-model.number="componentSettings[input.name]"
						:min="input.min"
						:max="input.max"
						:name="input.name"
						:id="'report-component-dim-' + input.name"
						:placeholder="input.placeholder"
						:required="false"
						:noMarginBottom="true"
						:step="input.step"
						:class="{'setting-group-input':true,'highlight':!!input.highlight}"
					/>
				</div>
			</div>

		</div>
		
	</div>
</template>

<script>
	import FormInput from "../Form/Input.vue";

	export default {
		name: "ReportComponentDims",
		components: {
			FormInput,
		},
		props: {
			componentSettings: {
				type: Object,
				default: () => ({}),
			},
			alignmentOptions: {
				type: Array,
				default: () => [],
			},
			ignoreInputs: {
				type: Array,
				default: () => [],
			},
			onlyInputs: {
				type: Array,
				default: () => [],
			},
			title: {
				type: String,
				default: "",
			},
			description: {
				type: String,
				default: "",
			},
			overrideInputs: {
				type: Object,
				default: () => ({})
			},
			toggleIt: {
				type: Number,
				default: 0
			},
			type: {
				type: String,
				default: 'Component'
			},
			hideToggle: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				toggled: false
			};
		},
		created() {
			this.toggled = !!this.hideToggle || !this.titleProcessed;
		},
		watch: {
			toggleIt: {
				handler() {
					this.toggled = true;
				},
			},
		},
		methods: {
			toggleItAction ( e, isParent ) {

				if ( isParent && this.toggled ) return;

				e.stopPropagation();

				this.toggled = !this.toggled;

			}
		},
		computed: {
			hasField () {
				let a = {};
				this.allowedInputs.forEach(function(input) {
					a[input] = this.allowedInputs.includes(input);
				}.bind(this));
				return a;
			},
			allInputs () {
				return ["alignment", "marginTop", "marginBottom", "marginLeft", "marginRight", "width", "height"];
			},
			firstInputs () {
				return ["alignment", "width", "height"];
			},
			titleProcessed () {
				let t = this.title;
				if ( !t ) {
					t = "Set Positioning";
					if ( this.hasField.height || this.hasField.width ) {
						t += " and Size";
					}
				}
				return t;
			},
			descriptionProcessed () {
				let d = this.description || '';
				if ( this.ignoredInputs.indexOf('marginTop') < 0 && this.type !== 'report' ) {
					if ( d ) {
						d += '<br>';
					}
					if ( this.ignoredInputs.indexOf('width') < 0 || this.ignoredInputs.indexOf('height') < 0 ) {
						d += 'Margins add padding around components, the % values of margins and width/height are relative to the page width. ';
					}
					else {
						d += 'Margins add padding around components, the % values are relative to the page width. ';
					}
				}
				if ( this.ignoredInputs.indexOf('alignment') < 0 && this.alignmentOptions.find((o) => o.value === 'absolute' ) ) {
					if ( d ) {
						d += '<br>';
					}
					d += this.type + 's are positioned relative to the components around them. To specify the exact position on the page, select Absolute in the Alignment dropdown.';
				}
				
				return d;
			},
			formInputs () {
				let all = [
					{
						label: this.componentSettings.alignment === "absolute" ? "% Distance From Top" : "Margin Top %",
						type: "number",
						min: 0,
						max: 95,
						step: 0.5,
						name: "marginTop",
						placeholder: '0'
					},
					{
						label: "Margin Bottom %",
						type: "number",
						min: 0,
						max: 95,
						step: 0.5,
						name: "marginBottom",
						placeholder: '0'
					},
					{
						label: this.componentSettings.alignment === "absolute" ? "% Distance From Left" : "Margin Left %",
						type: "number",
						min: 0,
						max: 95,
						step: 0.5,
						name: "marginLeft",
						placeholder: '0'
					},
					{
						label: "Margin Right %",
						type: "number",
						min: 0,
						max: 95,
						step: 0.5,
						name: "marginRight",
						placeholder: '0'
					},
					{
						label: "Width %",
						type: "number",
						min: 0,
						max: 100,
						step: 0.5,
						name: "width",
						placeholder: ''
					},
					{
						label: "Height %",
						type: "number",
						min: 0,
						max: 100,
						step: 0.5,
						name: "height",
						placeholder: ''
					}
				];
				all.forEach(function(input,index) {
					if ( this.overrideInputs[input.name] ) {
						Object.keys(this.overrideInputs[input.name]).forEach(function(k) {
							all[index][k] = this.overrideInputs[input.name][k];
						}.bind(this));
					}
				}.bind(this));
				let split = { first: [], second: [] };
				all.filter((i) => this.allowedInputs.indexOf(i.name) >= 0).forEach((input, index) => {
					if (this.firstInputs.indexOf(input.name) >= 0) {
						split.first.push(input);
					} else {
						split.second.push(input);
					}
				});
				return split;
			},
			ignoredInputs () {
				let ignored = [];
				this.ignoreInputs.forEach(function(input) {
					if ( input === 'margins' ) {
						ignored.push('marginBottom');
						ignored.push('marginRight');
						ignored.push('marginTop');
						ignored.push('marginLeft');
					}
					else {
						ignored.push(input);
					}
				});
				if ( this.componentSettings.alignment === "absolute" ) {
					ignored.push("marginBottom");
					ignored.push("marginRight");
				}
				return ignored;
			},
			allowedInputs() {
				let a = [...this.allInputs];
				a = a.filter((i) => this.ignoredInputs.indexOf(i) < 0);
				let onlyInputs = this.onlyInputs;
				if ( onlyInputs.indexOf('margins') >= 0 ) {
					onlyInputs.push('marginBottom');
					onlyInputs.push('marginRight');
					onlyInputs.push('marginTop');
					onlyInputs.push('marginLeft');
				}
				if (onlyInputs.length > 0) {
					a = a.filter((i) => onlyInputs.indexOf(i) >= 0);
				}
				return a;
			},
		},
	};
</script>

<style lang="less" scoped>
	@import "../../assets/css/less/_settings.less";
	.settings-group-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
		gap: 1rem;
		margin-bottom: 1rem;
		&.three {
			grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
		}
	}

	.setting-group {
		margin: 1rem 0 0;

		label {
			display: block;
			margin-bottom: 0.5rem;
			font-size: 14px;
			opacity: 0.8;
			font-weight: normal;
		}

		.settings-group-description {
			padding: 0;
			margin: 0 0 1rem;
		}

		.settings-group-title {
			margin-bottom: 0.5rem;
		}

		.large-button {
			&.mini {
				margin: 10px 20px 10px 0;
			}
		}

		.logo-preview {
			max-width: 250px;
			height: auto;
			max-width: 100px;
		}

		hr {
			margin: 2em 0;
		}
		.setting-group-input {
			&.highlight {
				
			}
		}
	
	}

	@keyframes pulse {
		0% {
			background-color: fade(@formDefaultColour, 15%);
		}
		50% {
			background-color: fade(@formDefaultColour, 25%);
		}
		100% {
			background-color: fade(@formDefaultColour, 15%);
		}
	}

	.toggled {
		background-color: fade(@formDefaultColour, 5%);
		padding: 1rem;
		border-radius: 0.5rem;
		margin-top: 1rem;
	}
	.toggle-link {
		cursor: pointer;
		opacity: 0.9;
		font-weight: normal;
		display: inline-block;
		margin-left: 0.4rem;
		&:hover {
			opacity: 1;
		}
	}
	// Enhanced styles for better discoverability of toggle sections
// Add these styles to your existing LESS files or create a new one to import

// Common styles for all three components
.settings-group, .table-settings-section, .setting-group {

	&.toggleable {

margin: 0.5rem 0 0 !important;

}
  
  // Enhanced styling when collapsed (not toggled)
  &:not(.toggled) {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border: 2px solid #dee2e6;
    border-radius: 12px;
    padding: 1rem 1.5rem;
    margin: 0 0 0;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    
    // Subtle animated gradient background
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
      transition: left 0.6s ease;
    }

	&.toggleable {
    
		&:hover {
		transform: translateY(-2px);
		box-shadow: 0 8px 25px rgba(0,0,0,0.1);
		border-color: #6c757d;
		
		&::before {
			left: 100%;
		}
		
		.toggle-link {
			color: #495057;
			font-weight: 600;
		}
		
		h4 {
			color: #495057;
		}
		}

	}
    
    // Add subtle pulse animation to draw attention
    animation: subtle-pulse 3s ease-in-out infinite;
  }
  
  // Enhanced h4 styling
  h4 {
    margin-bottom: 0.5rem;
    color: #6c757d;
    font-weight: 600;
    font-size: 1.1rem;
    transition: color 0.3s ease;
    
    // Add an icon before the title
    &::before {
      content: '⚙️';
      margin-right: 0.5rem;
      font-size: 1rem;
    }
  }
  
  // Specific icons for each component type
  &.settings-group h4::before {
    content: '📐'; // Page margins icon
  }
  
  &.table-settings-section h4::before {
    content: '📊'; // Table icon
  }
  
  &.graph-text-settings h4::before {
    content: '📈'; // Graph icon
  }
}

// Enhanced toggle link styling
.toggle-link {
  cursor: pointer;
  opacity: 0.8;
  font-weight: 500;
  display: inline-block;
  margin-left: 0.5rem;
  color: #6c757d;
  transition: all 0.3s ease;
  padding: 0.25rem 0.75rem;
  background: rgba(108, 117, 125, 0.1);
  border-radius: 20px;
  font-size: 0.85rem;
  border: 1px solid rgba(108, 117, 125, 0.2);
  
  &:hover {
    opacity: 1;
    background: rgba(108, 117, 125, 0.15);
    border-color: rgba(108, 117, 125, 0.3);
    transform: scale(1.05);
  }
  
  // Add arrow indicators
  &::after {
    content: ' →';
    transition: transform 0.3s ease;
  }
  
  // When section is toggled (expanded)
  .toggled & {
    background: rgba(220, 53, 69, 0.1);
    border-color: rgba(220, 53, 69, 0.3);
    color: #dc3545;
    
    &::after {
      content: ' ↑';
      transform: rotate(180deg);
    }
    
    &:hover {
      background: rgba(220, 53, 69, 0.15);
    }
  }
}

// Enhanced toggled (expanded) state
.toggled {
  background-color: fade(@formDefaultColour, 8%);
  padding: 1.5rem;
  border-radius: 12px;
  margin-top: 1rem;
  border: 2px solid fade(@formDefaultColour, 20%);
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  
  h4 {
    margin-bottom: 1.5rem;
    color: @formDefaultColour;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid fade(@formDefaultColour, 20%);
  }
}

// Pulse animation for attention
@keyframes subtle-pulse {
  0%, 100% {
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  }
  50% {
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  }
}

// Responsive adjustments
@media (max-width: 768px) {
  .settings-group, .table-settings-section, .setting-group {
    &:not(.toggled) {
      padding: 1rem;
      margin: 1rem 0;
    }
    
    h4 {
      font-size: 1rem;
    }
    
    .toggle-link {
      display: block;
      margin: 0.5rem 0 0 0;
      text-align: center;
    }
  }
}

// Additional fix for modal scroll containers
.modal-inner-scroll {
  .settings-group, .table-settings-section, .setting-group {
    &:not(.toggled) {
      // Ensure proper sizing within flex containers
      flex: none;
      width: 100%;
      box-sizing: border-box;
    }
  }
}

// Section-specific enhancements
.settings-group:not(.toggled) {
  // Page margins - blue theme
  border-left: 4px solid #007bff;
  
  &:hover {
    border-left-color: #0056b3;
  }
}

.table-settings-section:not(.toggled) {
  // Table settings - green theme  
  border-left: 4px solid #28a745;
  
  &:hover {
    border-left-color: #1e7e34;
  }
}

.graph-text-settings:not(.toggled) {
  // Graph settings - purple theme
  border-left: 4px solid #6f42c1;
  
  &:hover {
    border-left-color: #5a32a3;
  }
}

// Add subtle descriptions when collapsed
.settings-group:not(.toggled) h4::after {
  content: ' - Configure page layout and component positioning';
  font-size: 0.8rem;
  font-weight: normal;
  color: #6c757d;
  display: block;
  margin-top: 0.25rem;
}

.table-settings-section:not(.toggled) h4::after {
  content: ' - Customize table styling, borders, and colors';
  font-size: 0.8rem;
  font-weight: normal;
  color: #6c757d;
  display: block;
  margin-top: 0.25rem;
}

.graph-text-settings:not(.toggled) h4::after {
  content: ' - Set font sizes and colors for chart elements';
  font-size: 0.8rem;
  font-weight: normal;
  color: #6c757d;
  display: block;
  margin-top: 0.25rem;
}
</style>
